import React from 'react'
import { CardWrapper, StyledTitle, StyledContent, CardHeader } from './styled'

const InstitutionalCard = (props) => {
    return(
        <CardWrapper>
            <CardHeader>
                <img src={props.image.url} alt={props.image.alt}/>
            </CardHeader>
            <StyledTitle>{props.title}</StyledTitle>
            <StyledContent dangerouslySetInnerHTML={{__html: props.content}} />
        </CardWrapper>
    )
}

export default InstitutionalCard